import {
  defaultGapping,
  defaultLayouts,
  defaultPadding,
  defaultTypography,
  GSActionBar,
  GSEmptyList,
  GSInput,
  GSItemList,
  GSSelect,
  GSSidePanelPage,
  useMediaQuery,
} from "golfstatus_react_components";
import {
  faChevronLeft,
  faSearch,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useSearchParams } from "react-router-dom";

//import scss
import "./tournament-rounds-checkin.scss";
import { useNotificationAction, useNotificationBanner } from "../../../hooks/notificationHooks";
import { useCallback, useRef, useState } from "react";
import { useRoundHooks, getRoundName } from "../../../hooks/round/roundHooks";
import TournamentRoundsCheckinRound from "./tournament-rounds-checkin-round";
import { useDispatch, useSelector } from "react-redux";
import { selectLoading } from "../../../reducers/checkinSlice";
import { clearRoundNotifications, selectLoading as selectRoundLoading, selectRoundNotifications } from "../../../reducers/roundSlice";
import { useTournamentCheckins } from "../../../hooks/checkIn/checkInHooks";
import { usePusherTeamCheckin } from "../../../hooks/pusherHooks";

//Name the component
const TournamentRoundsCheckin = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  usePusherTeamCheckin();

  const loading = useSelector(selectLoading);
  const roundLoading = useSelector(selectRoundLoading);
  const isLoading = loading?.includes?.("getTournamentCheckIns") || roundLoading.includes("activateScorecards");

  const notifications = useSelector(selectRoundNotifications);
  const [searchParams, setSearchParams] = useSearchParams();
  const roundID = searchParams?.get?.("roundID");
  const roundName = searchParams?.get?.("roundName");

  const searchRef = useRef();

  const [search, setSearch] = useState("");

  const [roundFilter, setRoundFilter] = useState(
    roundID ? { label: `Round ${roundName}`, value: { id: roundID } } : null,
  );

  const { getRoundCheckins } = useTournamentCheckins(true);

  const { allRounds, updateTournamentRounds } = useRoundHooks();

  const checkinRounds = allRounds.map?.((r) => {
    return { ...r, checkIns: getRoundCheckins(r, search) };
  });

  

  const roundActivated = useCallback((notification) => {
    updateTournamentRounds()
  }, [updateTournamentRounds])

  useNotificationAction("created", notifications, roundActivated, "Round Live Scorecards" )

  const { isPhone } = useMediaQuery();

  const filteredRounds = roundFilter
    ? checkinRounds.filter?.((r) => r?.id === roundFilter?.value?.id)
    : checkinRounds.filter?.((r) => r.checkIns?.mappedCheckins?.length > 0);


  const mappedRounds = allRounds.map((r) => {
    return { label: `Round ${getRoundName(r)}`, value: r };
  });

  const leftNavigation = () => {
    navigate(-1);
  };

  const getNavigation = () => {
    //Add Title to your component
    return {
      title: `Team Check In`,
      leftIcon: faChevronLeft,
      leftButtonClick: leftNavigation,
    };
  };

  const updateSearch = (e) => {
    setSearch(e.target?.value);
  };

  const getSearchLayout = () => {
    return isPhone()
      ? defaultLayouts.vStack
      : defaultLayouts.hStack.align("flex-start", "center");
  };

  const getPosition = () => {
    if (!isPhone()) {
      return defaultLayouts.stickyTop;
    }
    return { position: "relative" };
  };

  const getEmptyList = () => {
    return (
      <GSEmptyList
        style={{ ...defaultPadding.smallLayoutPad.apply("vertical") }}
        title="We couldn't find who you were looking for..."
        detail="Try changing the search term."
        actions={[
          {
            title: "Clear Search",
            type: "grey",
            onClick: () => {
              setSearch("");
              setRoundFilter(null);
            },
          },
        ]}
      />
    );
  };

  const setRound = (option) => {
    setSearchParams(
      option?.value
        ? { roundID: option.value.id, roundName: getRoundName(option.value) }
        : {},
      { replace: true },
    );
    setRoundFilter(option);
  };

  const getSearchBar = () => {
    return (
      <div
        ref={searchRef}
        style={{
          ...getSearchLayout(),
          ...defaultPadding.xLargePad,
          ...defaultGapping.xLargeGap,
          borderBottom: "1px solid #eee",
          zIndex: 2,
          ...getPosition(),
          background: "white",
        }}
      >
        <GSInput
          textValue={search}
          onChange={updateSearch}
          leftIcon={faSearch}
          rightIcon={faTimesCircle}
          rightIconClick={() => {
            setSearch("");
          }}
          style={{ ...defaultLayouts.fullWidth }}
          placeholder="Search Players & Teams..."
        />
        {mappedRounds?.length > 1 ?
        <GSSelect
          isClearable
          options={mappedRounds}
          selectedOption={roundFilter}
          placeholder="Select a Round..."
          onChange={setRound}
          style={{ ...defaultLayouts.fullWidth }}
        /> : null}
        
      </div>
    );
  };

  const getRoundsList = () => {
    return (
      <GSItemList
        type="vertical"
        items={filteredRounds}
        listItem={(round) => {
          return (
            <TournamentRoundsCheckinRound
              offset={isPhone() ? 0 : searchRef.current?.clientHeight}
              round={round}
              filter={search}
              setSearch={setSearch}
              setRound={setRound}
            />
          );
        }}
        emptyMessage={getEmptyList()}
      />
    );
  };

  const getContent = () => {
    return (
      <gs-form>
        <GSActionBar
          header="Team Check In"
          style={{
            ...defaultPadding.xLargePad,
            ...defaultTypography.headline3,
            borderBottom: "1px solid #eeee",
          }}
        />
        {getSearchBar()}
        {getRoundsList()}
      </gs-form>
    );
  };

  const timeoutAction = () => {
    dispatch(clearRoundNotifications())
  };

  const [banner] = useNotificationBanner({ notifications, timeoutAction });

  return (
    //name the component tag
    <tournament-rounds-checkin>
      <GSSidePanelPage
        header={getNavigation()}
        banner={banner}
        content={getContent()}
        loading={isLoading}
      ></GSSidePanelPage>
    </tournament-rounds-checkin>
  );
};

//export the new name
export default TournamentRoundsCheckin;
